import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {map, switchMap, take} from 'rxjs/operators';
import {User} from '@spartacus/core';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {DcpUserService} from '../../services/user/dcp-user.service';

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationDoneGuard  {

  constructor(
    private userAccountFacade: UserAccountFacade,
    private userService: DcpUserService,
    private router: Router) {
  }

  /**
   * Checks if the current user needs to add C2B C2I Data.
   *
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.userAccountFacade.get().pipe(
      take(1),
      switchMap((user: User) => this.userService.isCustomerKnown(user).pipe(
        map((isCustomerKnown: boolean) => {
          if (isCustomerKnown && !this.skipRedirectionAfterRegistration()) {
            return this.router.parseUrl('/');
          }
          return true;
        })
      ))
    );
  }

  /**
   * (DCP-21404) Incorrect redirection from company address screen
   */
  skipRedirectionAfterRegistration(): boolean {
    return this.router.url?.includes('/configurator?');
  }
}
